var map = {
	"./ai-avatar-2x-1.png": 58175,
	"./ai-avatar-2x-10.png": 65295,
	"./ai-avatar-2x-11.png": 42630,
	"./ai-avatar-2x-12.png": 67517,
	"./ai-avatar-2x-13.png": 46388,
	"./ai-avatar-2x-14.png": 92299,
	"./ai-avatar-2x-2.png": 3524,
	"./ai-avatar-2x-3.png": 43469,
	"./ai-avatar-2x-4.png": 87314,
	"./ai-avatar-2x-5.png": 85179,
	"./ai-avatar-2x-6.png": 6848,
	"./ai-avatar-2x-7.png": 78025,
	"./ai-avatar-2x-8.png": 49118,
	"./ai-avatar-2x-9.png": 67431,
	"./ai-avatar-2x-zhang-v2.png": 73431,
	"./ai-avatar-2x-zhang.png": 11328
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87706;